import React, { useState, useEffect, useCallback } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import './SearchBar.css';

interface SearchBarProps {
  onSearch?: (query: string) => Promise<void> | void; // CORRECTION: Rendre optionnel et accepter les deux types
  onChange?: (value: string) => void; // NOUVEAU: Prop alternative pour les changements immédiats
  onClear?: () => void; // NOUVEAU: Prop pour effacer
  placeholder?: string;
  isLoading?: boolean;
  loading?: boolean; // NOUVEAU: Prop alternative pour le loading
  value?: string; // NOUVEAU: Prop pour la valeur contrôlée
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  onChange,
  onClear,
  placeholder = "Rechercher une commande...",
  isLoading = false,
  loading = false,
  value
}) => {
  const [searchQuery, setSearchQuery] = useState(value || '');

  // Synchroniser avec la prop value si elle existe
  useEffect(() => {
    if (value !== undefined) {
      setSearchQuery(value);
    }
  }, [value]);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearch) {
      await onSearch(searchQuery);
    }
  }, [searchQuery, onSearch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchQuery(newValue);

    // Si onChange est défini, l'utiliser (pour les changements immédiats)
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleClearClick = () => {
    setSearchQuery('');
    if (onClear) {
      onClear();
    } else if (onChange) {
      onChange('');
    }
  };

  const isLoadingState = isLoading || loading;

  return (
    <form className="search-bar" onSubmit={handleSubmit}>
      <div className="search-input-wrapper">
        {isLoadingState ? (
          <div className="search-loading"></div>
        ) : (
          <SearchIcon className="search-icon" />
        )}
        <input
          type="text"
          value={searchQuery}
          onChange={handleChange}
          placeholder={placeholder}
          className="search-input"
          disabled={isLoadingState}
        />
        {searchQuery && (
          <button
            type="button"
            className="clear-button"
            onClick={handleClearClick}
            aria-label="Effacer la recherche"
          >
            ×
          </button>
        )}
      </div>
    </form>
  );
};

export default SearchBar;